import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '20fr 1fr',
    backgroundColor: theme.palette.background.default,
    borderRadius: 10,
    alignItems: 'center',
    paddingLeft: 12,
    transition: 'background-color 0.3s ease-in-out',
    height: 100,
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    }
  },
  endpointcontainer: {
    lineBreak: 'anywhere'
  },
  circularProgressContianer: {
    marginTop: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1
  },
  menuIcon: {
    justifySelf: 'end',
    marginRight: 30
  },
  tableRowExceptMenuItem: {
    display: 'grid',
    columnGap: 0,
    gridTemplateColumns: '3fr 3fr 3fr 3fr 3fr 5fr',
    alignItems: 'center',
    height: 100,
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.background.paper
    }
  },
  icon: {
    fontSize: 42,
    marginTop: 24,
    marginBottom: 16
  }
}))

export default useStyles
